import { FundType } from '../fundType';

export class FundAllocationList {
    year: string;
    amount: number;
    description: string;
    fundType: FundType;

}